import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Pressable, StyleSheet, View } from 'react-native';

import { BodyText, Icon, theme } from '@sg/garnish';

export const ScanToPayAddPaymentMethodOption = (props: ScanToPayAddPaymentMethodOptionProps) => {
  const { onAddPaymentMethod } = props;

  const { formatMessage } = useIntl();
  const title = formatMessage(messages.title);

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={title}
      style={styles.cta}
      onPress={onAddPaymentMethod}
    >
      <View style={styles.icon}>
        <Icon name="IconPlus" width={24} height={24} />
      </View>

      <BodyText sizeMatch={['24']}>{title}</BodyText>
    </Pressable>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Add new card',
    description: 'Scan to Pay | Payment Method Option | A11y',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  cta: {
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 40,
    borderRadius: 40,
    gap: theme.spacing['3'],
    paddingHorizontal: theme.spacing['4'],
    marginHorizontal: theme.spacing['4'],
  },
  icon: {
    width: 32,
    height: 32,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanToPayAddPaymentMethodOptionProps = {
  onAddPaymentMethod: () => void;
};
